import { Feedback, Input, Label } from '@availity/form';
import { faGear } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useState } from 'react';
import SectionEditorModal from '../../SectionEditorModal/SectionEditorModal';
import { DocumentSection } from '../../../../slices/marketplace/timeline/models/document-section.model';
import { DocumentDetails } from '../../../../slices/marketplace/timeline/models/document-details.model';
import './MarketplaceDocumentSectionField.scss';
interface MarketplaceDocumentSectionFieldProps {
    documentsSections: DocumentSection[];
    disabled: boolean;
    setDocumentSectionList: (sections: DocumentSection[]) => void;
    documentDetailsList: DocumentDetails[];
    type: 'buyers' | 'sellers';
    selectedDocumentId?: string;
    sectionsModalMode: 'built-in' | 'external-modal';
    onSectionsButtonClick?: () => void;
    label?: string;
}
export const MarketplaceDocumentSectionField = (
    props: MarketplaceDocumentSectionFieldProps
) => {
    const [isSectionEditorModalVisible, setIsSectionEditorModalVisible] =
        useState(false);

    const getSectionId = () => {
        if (!props.selectedDocumentId) return undefined;
        const selectedDocument = props.documentDetailsList.find(
            (doc) => doc.id === props.selectedDocumentId
        );
        if (!selectedDocument) return undefined;
        return selectedDocument.sectionId;
    };

    return (
        <div className="marketplace-document-section-field">
            <Label for="documentSection">{props.label ?? 'Document Section'}</Label>
            <FontAwesomeIcon
                className="cursor-pointer"
                onClick={() =>
                    props.sectionsModalMode === 'external-modal'
                        ? props.onSectionsButtonClick()
                        : setIsSectionEditorModalVisible(true)
                }
                icon={faGear}
            />
            {props.selectedDocumentId ? (
                <Input
                    type="select"
                    name="documentSection"
                    disabled={props.disabled}
                    value={getSectionId()}>
                    <option value={-1}>Select</option>
                    {props.documentsSections.filter(s => !s.isLoiSection).map((option) => (
                        <option
                            key={`section-${option.id}`}
                            value={option.id}
                            disabled={
                                // [#1301] Only a resume puts a document into a Pre-suspension Archive.
                                option.isArchive ||
                                (props.type === 'buyers' &&
                                    !option.isAvailableForBuyers) ||
                                (props.type === 'sellers' &&
                                    !option.isAvailableForSellers)
                            }>
                            {option.name}
                        </option>
                    ))}
                </Input>
            ) : (
                <Input
                    type="select"
                    name="documentSection"
                    disabled={props.disabled}>
                    <option value={-1}>Select</option>
                    {props.documentsSections.filter(s => !s.isLoiSection && !s.isArchive).map((option) => (
                        <option
                            key={`section-${option.id}`}
                            value={option.id}
                            disabled={
                                (props.type === 'buyers' &&
                                    !option.isAvailableForBuyers) ||
                                (props.type === 'sellers' &&
                                    !option.isAvailableForSellers)
                            }>
                            {option.name}
                        </option>
                    ))}
                </Input>
            )}
            <Feedback name="documentSection" />
            {isSectionEditorModalVisible && (
                <SectionEditorModal
                    documentsSections={props.documentsSections}
                    isVisible={isSectionEditorModalVisible}
                    onClose={() => setIsSectionEditorModalVisible(false)}
                    setDocumentSectionList={props.setDocumentSectionList}
                    documentDetailsList={props.documentDetailsList}
                    sectionsModalMode={props.sectionsModalMode}
                />
            )}
        </div>
    );
};
